import { EnvironmentOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Empty, Typography } from "antd";
import { motion } from "framer-motion";

const { Paragraph } = Typography;

interface AccountAddressEmptyStateProps {
  onCreate: () => void;
}

export const AccountAddressEmptyState = ({
  onCreate,
}: AccountAddressEmptyStateProps) => (
  <motion.div
    initial={{ opacity: 0, y: 18 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.22 }}
  >
    <div className="account-address-empty">
      <div className="account-address-empty__icon">
        <EnvironmentOutlined />
      </div>
      <Empty
        description="Bạn chưa lưu địa chỉ nào cho tài khoản này."
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
      <Paragraph type="secondary">
        Thêm sổ địa chỉ để checkout nhanh hơn, giảm thao tác nhập lại thông tin
        giao nhận ở các lần mua sau.
      </Paragraph>
      <Button icon={<PlusOutlined />} onClick={onCreate} type="primary">
        Thêm địa chỉ mới
      </Button>
    </div>
  </motion.div>
);
